"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalSeparationFieldView = exports.Styles = exports.CSS = void 0;
exports.canUpdate = canUpdate;
var core_shared_1 = require("@ikegps/core-shared");
var field_action_button_1 = require("../../../components/button/field.action.button");
var vertical_separation_input_state_1 = require("../../../components/input/vertical.separation.input.state");
var notification_service_1 = require("../../../components/notification.toast/notification.service");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var page_state_1 = require("../../../state/page.state");
var capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    container: 'c-PMLink',
    isHovered: 'c-PMLink--hovered',
    isLinked: 'c-PMLink--linked',
    height: 'c-PMLink__Height'
};
exports.Styles = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.isHovered] = {
        'font-weight': 'bold'
    },
    _a[exports.CSS.isLinked] = {
        cursor: 'pointer'
    },
    _a[exports.CSS.height] = {
        width: '100%'
    },
    _a);
(0, theme_1.addStyles)(exports.Styles);
function selectDrawable(draw, drawableId) {
    draw.state.setSelected(drawableId, null);
    return false;
}
function hoverDrawable(captureId, drawableId, hovered) {
    var draw = page_state_1.CurrentState.CollectionEdit.getIkeDraw(captureId);
    if (draw == null) {
        return;
    }
    if (hovered) {
        draw.state.setHovered(drawableId);
    }
    else if (draw.state.hoverId === drawableId) {
        draw.state.setHovered(null);
    }
}
function canUpdate() {
    return true;
}
exports.VerticalSeparationFieldView = {
    viewInline: function (field) {
        return core_shared_1.IkeUnit.display(field.value, services_1.Services.UserSettings.units === 'meters' ? core_shared_1.IkeUnit.CENTIMETER : core_shared_1.IkeUnit.INCH, null, null, 0);
    },
    hasDetail: function (field) {
        return field.getCaptures().length > 0;
    },
    viewDetail: function (field) {
        if (!exports.VerticalSeparationFieldView.hasDetail(field)) {
            return null;
        }
        var capture = field.getCaptures()[0];
        var title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
        return capture_thumbnail_1.CaptureThumbnail.view(field.collection, capture, { crosshair: true, title: title });
    },
    viewEdit: function (field, ctrl) {
        if (!canUpdate()) {
            return exports.VerticalSeparationFieldView.viewInline(field, ctrl);
        }
        var currentDraw = page_state_1.CurrentState.CollectionEdit.currentDraw;
        var canLinkTo = currentDraw != null && currentDraw.drawState.hasMeasurements();
        var inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new vertical_separation_input_state_1.VerticalSeparationInputState(field.schema.displayName);
            ctrl.changeState.addState(field.id, inputState);
        }
        inputState.validateInput(field.stateValue);
        if (field.hasValue()) {
            var className = exports.CSS.container;
            var heightInline = exports.VerticalSeparationFieldView.viewInline(field, ctrl);
            if (currentDraw != null) {
                var stateValue_1 = field.stateValue;
                var drawableTopId_1 = field.stateValue.drawableTop;
                var drawableBottomId = field.stateValue.drawableBottom;
                // If the current field is hovered
                if (currentDraw.state.hoverId === drawableTopId_1 || currentDraw.state.hoverId === drawableBottomId) {
                    className = className + ' ' + exports.CSS.isHovered;
                }
                // If the current field is part of the currentDrawable allow it to select the drawable
                var onclick_1 = null;
                if (stateValue_1.captureId === currentDraw.capture.objectId) {
                    className = className + ' ' + exports.CSS.isLinked;
                    onclick_1 = function () { return selectDrawable(currentDraw, drawableTopId_1); };
                }
                // Set the hoverId for the drawable
                var onmouseover_1 = function () { return hoverDrawable(stateValue_1.captureId, drawableTopId_1, true); };
                var onmouseout_1 = function () { return hoverDrawable(stateValue_1.captureId, drawableTopId_1, false); };
                return (0, mithril_1.m)('div', { className: className, onmouseover: onmouseover_1, onmouseout: onmouseout_1 }, [
                    (0, mithril_1.m)('span', { className: exports.CSS.height, onclick: onclick_1 }, heightInline)
                ]);
            }
            return (0, mithril_1.m)('div', { className: className }, heightInline);
        }
        if (!canLinkTo) {
            return this.viewInline(field, ctrl);
        }
        var linkFieldIds = currentDraw.state.linkFieldIds;
        if (linkFieldIds.indexOf(field.id) !== -1) {
            return field_action_button_1.FieldActionButton.viewLinkVerticalSeparation({
                linking: true,
                onclick: function () { return currentDraw.state.setTool(null); }
            });
        }
        // No fields are being linked show the link start behavior
        return field_action_button_1.FieldActionButton.viewLinkVerticalSeparation({
            joinable: ctrl.getJoin(field) != null,
            hasTop: field.hasDrawableTop(),
            hasBottom: field.hasDrawableBottom(),
            hasError: inputState.hasError(),
            onclick: function () {
                page_state_1.CurrentState.cancelInteractions();
                var oppositeJoin = ctrl.getOppositeJoin(field);
                if (oppositeJoin != null) {
                    currentDraw.state.setLinkFields([field.id, oppositeJoin.field.id]);
                    notification_service_1.NotificationService.info({ key: i18n_1.T.PHOTOMEASURE_JOIN_START, attrs: oppositeJoin.getTitle() });
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'measurement:join', ctrl.collection.revision, 1);
                }
                else {
                    currentDraw.state.setLinkFields([field.id]);
                }
            }
        });
    },
    hasClear: function (field) {
        return field.hasValue() || field.hasDrawableTop();
    }
};
//# sourceMappingURL=vertical.separation.field.view.js.map